import { Component, h } from "@lukekaalim/act"
import { html } from "@lukekaalim/act-web"

import classes from './ToolSlotRenderer.module.css';
import { ToolKey, ToolState } from "../../defs";
import { TheatreSceneResources, TheatreState } from "../../hooks";
import { assetsURLs } from "../../assets";
import { getHandlerForTool } from "./handler";
import { Kenney } from "@vendor/kenney";

export type ToolSlotRenderer = {
  tool: ToolState,

  beltSlotIndex?: null | number,

  selected?: boolean,
  shortcutKey?: string | null,
  draggable?: boolean,

  state: TheatreState,

  onClick?(e: PointerEvent): void,
  onDragStart?(e: DragEvent): void,
  onDblClick?(e: MouseEvent): void,
}

const ToolTypeIcons: { [Key in ToolKey]: string } = {
  'dev:vis':      assetsURLs.icons.bug,

  'dice:cleanup': assetsURLs.icons.dice,
  'dice:roll':    assetsURLs.icons.dice,
  'minis:delete': assetsURLs.icons.mini,
  'minis:move':   assetsURLs.icons.mini,
  'minis:place':  assetsURLs.icons.mini,

  'selection:deselect': assetsURLs.icons.selection,
  'selection:select':   assetsURLs.icons.selection,

  'terrain:paint':            assetsURLs.icons.terrain_brush,
}

const ToolTypeColors: { [Key in ToolKey]: string } = {
  'dev:vis':      'green',

  'dice:cleanup': 'red',
  'dice:roll':    'red',

  'minis:delete': '#4650d8',
  'minis:move':   '#4650d8',
  'minis:place':  '#4650d8',

  'selection:deselect': '#e2883f',
  'selection:select':   '#e2883f',

  'terrain:paint':            '#da4690',
}

export const ToolSlotRenderer: Component<ToolSlotRenderer> = ({
  tool, state,
  beltSlotIndex = null,
  selected = true,
  shortcutKey = null,
  draggable,

  onClick,
  onDragStart,
  onDblClick,
}) => {
  const handler = getHandlerForTool(tool.type);

  return h(html.div, {
    draggable,
    classList: [classes.selectionBorder, selected && classes.selectedTool],
    onClick, onDragStart, onDblClick,
    style: {
      '--tool-primary-color': ToolTypeColors[tool.type]
    }
  },
    h(html.button, { className: classes.innerContainer }, [
      !!handler && !!handler.ToolbeltComponent && h(html.div, { className: classes.handler },
        h(handler.ToolbeltComponent, {
          toolState: tool,
          theatre: state,
          beltSlotIndex: beltSlotIndex || 0,
        })
      ),
      beltSlotIndex !== null && h(html.div, { className: classes.keyboardIcon }, h(html.img, {
        src: {
          [0]: Kenney.input.keyboardAndMouse.keyboard_1_outline.href,
          [1]: Kenney.input.keyboardAndMouse.keyboard_2_outline.href,
          [2]: Kenney.input.keyboardAndMouse.keyboard_3_outline.href,
          [3]: Kenney.input.keyboardAndMouse.keyboard_4_outline.href,
          [4]: Kenney.input.keyboardAndMouse.keyboard_5_outline.href,
          [5]: Kenney.input.keyboardAndMouse.keyboard_6_outline.href,
          [6]: Kenney.input.keyboardAndMouse.keyboard_7_outline.href,
          [7]: Kenney.input.keyboardAndMouse.keyboard_8_outline.href,
          [8]: Kenney.input.keyboardAndMouse.keyboard_9_outline.href,
        }[beltSlotIndex] || ''
      }) ),
      h(html.div, { className: classes.typeIcon },
        h(html.img, { src: ToolTypeIcons[tool.type] })
      ),
    ]),
  );
};


export const SlotStateIcon: Component = ({ children }) => {
  return h(html.div, { className: classes.slotStateIcon }, [
    children
  ]);
}